import { z } from "zod";

/** Configuration d'un pays servie par l'API ; rien de national n'est codé en dur ailleurs. */

export const LanguageConfig = z.object({
  code: z.string(), // BCP-47 : "fr", "wo"
  name: z.string(),
  nativeName: z.string().nullable(),
  isInstruction: z.boolean(),
  orthography: z.string().nullable(),
});

export const GradeConfig = z.object({
  id: z.string(),
  code: z.string(), // "3E"
  label: z.string(), // "3e"
  ordinal: z.number().int(), // 1..13, comparable entre pays
  cycleCode: z.string(),
  cycleLabel: z.string(),
  examCodes: z.array(z.string()), // examens rattachés à cette classe
});

export const TrackConfig = z.object({
  id: z.string(),
  code: z.string(),
  label: z.string(),
  seriesVersion: z.string(),
});

export const ExamConfig = z.object({
  code: z.string(), // "BFEM"
  label: z.string(),
  gradeCode: z.string(),
  organizer: z.string().nullable(),
  passMark: z.number(),
  scaleMax: z.number(),
});

export const PlanPriceConfig = z.object({
  planId: z.string(),
  label: z.string(),
  months: z.number().int().nullable(),
  isExamPass: z.boolean(),
  amount: z.number().int(), // en unité entière de la devise
  /** Fonctionnalités comprises (grille du studio), pour l'écran d'abonnement. */
  includes: z.array(z.string()).optional(),
});

export const PaymentProviderConfig = z.object({
  id: z.string(), // "wave"
  label: z.string(),
  priority: z.number().int(),
  supportsRefundApi: z.boolean(),
  supportsMandate: z.boolean(),
});

export const CountryConfig = z.object({
  id: z.string().length(2),
  name: z.string(),
  currency: z.string().length(3),
  timezone: z.string(),
  defaultLocale: z.string(),
  schoolYear: z.object({
    id: z.string(),
    label: z.string(),
    startsOn: z.string(), // ISO date
    endsOn: z.string(),
  }),
  languages: z.array(LanguageConfig),
  grades: z.array(GradeConfig),
  tracks: z.array(TrackConfig),
  exams: z.array(ExamConfig),
  subjects: z.array(z.object({ id: z.string(), label: z.string() })),
  paymentProviders: z.array(PaymentProviderConfig),
  plans: z.array(PlanPriceConfig),
  /** Durée de l'essai gratuit (jours), réglée dans le studio. */
  trialDays: z.number().int().optional(),
  /** Délai de grâce après la fin payée (jours), réglé dans le studio. */
  graceDays: z.number().int().optional(),
  privacy: z.object({
    dataAuthority: z.string().nullable(),
    dataRegime: z.enum(["DECLARATION", "AUTHORIZATION"]),
    digitalConsentAge: z.number().int(),
    crossBorderNotice: z.boolean(),
    policyVersion: z.string(),
  }),
});
export type CountryConfig = z.infer<typeof CountryConfig>;
